function convertHexToRGBA (colorHex, alpha) {
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(colorHex)) {
    let color = colorHex.substring(1).split('')
    if (color.length === 3) {
      color = [color[0], color[0], color[1], color[1], color[2], color[2]]
    }
    color = '0x' + color.join('')
    return alpha
      ? `rgba(${[(color >> 16) & 255, (color >> 8) & 255, color & 255].join(
        ','
      )}, ${alpha})`
      : `rgba(${[(color >> 16) & 255, (color >> 8) & 255, color & 255].join(
        ','
      )}, 1)`
  }
}

export default convertHexToRGBA